"use client";

import React from "react";
import { cn } from "@/lib/utils";
import Image from "@/helpers/Image";
import grid from "@/public/innercircle/grid.svg";
import noise from "@/public/innercircle/noise.png";

export default function GridNoise({ className = "" }: { className?: string }) {
  return (
    <>
      <Image
        src={grid}
        alt="grid"
        className="absolute z-0 inset-0 lg:!w-full !h-full opacity-50 object-none lg:object-cover"
      />
      <Image
        src={noise}
        alt="noise"
        className="absolute z-0 inset-0 lg:!w-full !h-full opacity-50 mix-blend-color object-none lg:object-cover"
      />
    </>
  );
}
